(function(window, beforeAfterPlayControlsViewFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.BeforeAfterPlayControlsView = beforeAfterPlayControlsViewFactory(namespace.templates, namespace.events, namespace.localizationStrings, namespace.viewHelper, namespace.tabIndex, namespace.highlightDisabler, namespace.playerConfiguration);
})(this, function(templates, events, localizationStrings, viewHelper, tabIndex, highlightDisabler, playerConfiguration) {
   'use strict';

   var rightParenRegex = /\)/gi;
   var leftParenRegex = /\(/gi;

   /**
    * @memberof TSC
    * @class BeforeAfterPlayControlsView
    * @classdesc View containing the large play video and replay video buttons at the beginning and end of videos
    */
   var BeforeAfterPlayControlsView = function($container) {
      var _markup;
      var _$videoClickToPlayLink;
      var _$videoClickToReplayLink;
      var _$videoClickToPlayGraphic;
      var _$videoClickToReplayGraphic;
      var _videoElementHasLoaded = false;

      var onPlayHandler = function(e) {
         e.preventDefault();
         if (playerConfiguration.disableInteractions) {
            return;
         }

         hideVideoClickToPlayLink();
         if (_videoElementHasLoaded) {
            $container.trigger(events.Controls.PlayControl);
         } else {
            $container.trigger(events.Controls.LoadAndPlayControl);
         }
      };

      var showVideoClickToPlayLink = function() {
         _$videoClickToPlayLink.show();
      };

      var hideVideoClickToPlayLink = function() {
         _$videoClickToPlayLink.hide();
      };

      var setVideoClickToPlayErrorState = function(state) {
         if (state) {
            _$videoClickToPlayLink.addClass('video-click-to-play-error');
         } else {
            _$videoClickToPlayLink.removeClass('video-click-to-play-error');
         }
      };

      var hideVideoClickToReplayLink = function() {
         _$videoClickToReplayLink.hide();
      };

      var showVideoClickToReplayLink = function() {
         _$videoClickToReplayLink.show();

         if (viewHelper.elementOrChildHasFocus($container)) {
            _$videoClickToReplayGraphic.focus();
            highlightDisabler.disableHighlights(_$videoClickToReplayGraphic);
         }
      };

      var addVideoClickToPlayBackground = function(posterSrc) {
         posterSrc = posterSrc.replace(rightParenRegex, '\\\)');
         posterSrc = posterSrc.replace(leftParenRegex, '\\\(');

         var url = 'url(' + posterSrc + ')';
         _$videoClickToPlayLink.css('background-image', url);
         _$videoClickToReplayLink.css('background-image', url);
      };

      var replayHandler = function() {
         hideVideoClickToReplayLink();
         $container.trigger(events.Media.Replay);
      };

      var createView = function() {
         _markup = templates.before_after_play_controls_template({
            playIndex: tabIndex.InitialPlay,
            replayIndex: tabIndex.EndReplay,
            playButtonIndex: tabIndex.Disabled,
            replayButtonIndex: tabIndex.Disabled,
            accessBtnClickToPlay: localizationStrings.strings.accessBtnPlay,
            accessBtnClickToReplay: localizationStrings.strings.accessBtnClickToReplayLink
         });
         $container.find('.before-after-play-controls').html(_markup);

         _$videoClickToPlayLink = $container.find('.video-click-to-play-link');
         _$videoClickToReplayLink = $container.find('.video-click-to-replay-link');
         _$videoClickToPlayGraphic = $container.find('.video-click-to-play');
         _$videoClickToReplayGraphic = $container.find('.video-click-to-replay');

         _$videoClickToReplayLink.hide();

         if (viewHelper.elementOrChildHasFocus($container)) {
            _$videoClickToPlayGraphic.focus();
            highlightDisabler.disableHighlights(_$videoClickToPlayGraphic);
         }
      };

      var bindEvents = function() {
         _$videoClickToReplayLink.on('click', replayHandler);
         _$videoClickToPlayLink.on('click', onPlayHandler);
      };

      var disableClickToPlayEvents = function() {
         _$videoClickToPlayLink.addClass('noClickToPlayEvents');
      };

      var destroy = function() {
         _$videoClickToReplayLink.off('click', replayHandler);
         _$videoClickToPlayLink.off('click', onPlayHandler);
      };

      createView();
      bindEvents();

      return Object.defineProperties(
         {
            showVideoClickToPlayLink: showVideoClickToPlayLink,
            hideVideoClickToPlayLink: hideVideoClickToPlayLink,
            setVideoClickToPlayErrorState: setVideoClickToPlayErrorState,
            hideVideoClickToReplayLink: hideVideoClickToReplayLink,
            showVideoClickToReplayLink: showVideoClickToReplayLink,
            addVideoClickToPlayBackground: addVideoClickToPlayBackground,
            disableClickToPlayEvents: disableClickToPlayEvents,
            destroy: destroy
         },
         {
            videoElementHasLoaded: {
               get: function() {
                  return _videoElementHasLoaded;
               },
               set: function(videoElementHasLoaded) {
                  _videoElementHasLoaded = videoElementHasLoaded;
               }
            }
         });
   };

   return {
      /**
       *  Factory method that returns a new BeforeAfterPlayControlsView object.
       *  @function create
       *  @memberof TSC.BeforeAfterPlayControlsView
       *  @static
       *  @param {Object} $container - jQuery element that contains a .before-after-play-controls element where the before and after play controls will be injected
       *  @return new BeforeAfterPlayControlsView instance
       */
      create: BeforeAfterPlayControlsView
   };
});
